import { useCallback, useMemo } from "react";
import { CODE_GAMMME_PAC_VALUES } from "../constants";
import { getFiltresData } from "utils/engine/engine";
import { BOILER_TYPE_GROUND, BOILER_TYPE_WALL } from "utils/helpers/boilerType";
import { useCurrentEtudeData } from "./useCurrentEtudeData";
import { InstallationType } from "./useGetSolutionsQuery";

export const useDefaultFilters = (network?: string) => {
  const { hasEcs, service, installationType } = useCurrentEtudeData();
  const codeGammePacDefault = useMemo(
    () =>
      hasEcs
        ? CODE_GAMMME_PAC_VALUES.filter((v) => v !== "AHP60")
        : CODE_GAMMME_PAC_VALUES,
    [hasEcs]
  );

  const filtresDefault = getFiltresData(network, service).allData;

  const getDefaultFilters = useCallback(
    (type?: InstallationType) => {
      const typeName =
        type == InstallationType.electric ? "electric" : "hybride";
      let defaultFilters: {
        part_pac?: number;
        taux_couverture?: number;
        appoint?: boolean[];
        preference_pac?: string[];
        type_chaudiere?: string[];
      } = {}; //= { preference_pac: PREFERENCE_PAC_VALUES };

      if (filtresDefault[typeName].part_pac.default != "empty") {
        defaultFilters.part_pac = filtresDefault[typeName].part_pac.default;
      }
      if (filtresDefault[typeName].taux_couverture?.default != "empty") {
        defaultFilters.taux_couverture =
          filtresDefault[typeName].taux_couverture?.default;
      }

      if (type == InstallationType.hybride) {
        defaultFilters.type_chaudiere = [BOILER_TYPE_GROUND, BOILER_TYPE_WALL];
      }

      return defaultFilters;
    },
    [installationType]
  );

  return { getDefaultFilters, codeGammePacDefault };
};
